import { render, staticRenderFns } from "./new_component.vue?vue&type=template&id=1f3aea4c"
import script from "./new_component.vue?vue&type=script&lang=js"
export * from "./new_component.vue?vue&type=script&lang=js"
import style0 from "./new_component.vue?vue&type=style&index=0&id=1f3aea4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports